var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-item"},[_c('img',{attrs:{"src":_vm.$props.image,"alt":""}}),_c('span',{staticClass:"ui-item-title"},[_vm._v(_vm._s(_vm.$props.title))]),_c('base-button',{on:{"click":_vm.updateComponent}},[_vm._v(_vm._s(_vm.$props.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }